const {databaseServer} = require("../config/network");

const getAssetTypes = async (token) => {
    return fetch(`${databaseServer}/asset-types`, {
        headers: new Headers({
            'Authorization': token
        })
    })
        .then(response => response.json() )
        .catch(error => console.log(error));
}

module.exports = {
    getAssetTypes
}